import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input'];
  static values = {
    kind: String,
    itemId: String,
  };

  connect() {
    this._renderLabels();
  }

  toggle(event) {
    this._renderLabels();
    this.dispatch('toggled', {
      detail: {
        ...this.identity,
        dimension: event.target.dataset.dimension,
        checked: event.target.checked,
      },
    });
  }

  setChecked(dimension, checked) {
    const input = this.inputFor(dimension);
    if (input && input.checked !== checked) {
      input.checked = checked;
      this._renderLabels();
    }
  }

  hasDimension(dimension) {
    return !!this.inputFor(dimension);
  }

  checkedFor(dimension) {
    return !!this.inputFor(dimension)?.checked;
  }

  inputFor(dimension) {
    return this.inputTargets.find((input) => input.dataset.dimension === dimension);
  }

  get identity() {
    return { kind: this.kindValue, id: this.itemIdValue };
  }

  _renderLabels() {}
}
